import React, { Component } from 'react';
import { connect } from 'react-redux';
import AnswerSingle from '../AnswerSingle';
import AnswerCheckbox from '../AnswerCheckbox';
import AnswerRadioButton from '../AnswerRadioButton';
import AnswerType from '../AnswerType';
import messages from './messages';

const GroupCard = ({ children }) => {
	return (
		<div id='GroupCard'>
			{children}
		</div>
	);
};

class GroupStep extends Component{
	constructor(props) {
		super(props);
		this.state = {
			value: [],
			options: []
		};
	}
	
	componentWillMount() {
		this.setState({
			value: this.props.value || []
		});
	}
	
	onGroupVariantChanged = (i, v) => {
		let { value, options } = this.state;
		const { questionId } = this.props;
		value[i] = v;
		this.setState({
			value
		});
		if (value.filter(o => o || o === 0).length + options.filter(o => o || o === 0).length >= questionId.length ) {
			this.props.onVariantChanged(value, options);
		}
	};
	onGroupOptionsChanged = (i, v) => {
		let { options, value} = this.state;
		const { questionId } = this.props;
		options[i] = v;
		this.setState({
			options
		});
		
		if (value.filter(o => { return o || o === 0}).length + options.filter(o => o || o === 0).length >= questionId.length) {
			this.props.onVariantChanged(value, options);
		}
	};
	
	render() {
		const { questionId } = this.props;
		const { value } = this.state;
		return (
			<GroupCard {...this.props}>
				{questionId.map((d, i) => {
					return (<Answer key={i}
					                value={value[i]}
					                questionId={d}
					                onOptionsChanged={v => this.onGroupOptionsChanged(i, v)}
					                onVariantChanged={v => this.onGroupVariantChanged(i, v)}/>);
				})}
			</GroupCard>
		);
	}
};

const mapStateToProps = ({ survey: { answers, questions, survey, currentStep } }) => {
	return {
		currentStep, answers, questions, survey
	};
};

const getAnswer = (type) => {
	switch (type) {
		case 'single': {
			return AnswerSingle;
		}
		case 'checkbox': {
			return AnswerCheckbox;
		}
		case 'radio': {
			return AnswerRadioButton;
		}
		default: break;
	}
	
	return AnswerType;
};

const Answer = connect(mapStateToProps)(({ questionId, ...props }) => {
	const { questions } = props;
	if ((!questionId && questionId !== 0) || !questions) return null;
	const C = !Array.isArray(questionId) ? getAnswer(questions[questionId].type) : GroupStep;
	return (
		<C {...props} messages={messages} questionId={questionId}/>
	);
});

export default Answer;


// WEBPACK FOOTER //
// ./src/components/Answer/Answer.js